import { TFunction } from 'i18next';

export const getSearchMenuOptions = (t: TFunction) => {
  return [
    { value: 'user', label: t('member.type.member') },
    { value: 'community', label: t('community') },
    { value: 'program', label: t('program') },
  ];
};
